export default __webpack_public_path__ + "static/media/404_error.8425efb9.svg";